import get from 'lodash/get';
import { useSelector } from 'react-redux';
import * as dataSelectors from '../data/data-selectors';
import { DEFAULT_TRANSLATIONS, TranslationTypes } from './constants';
import { translateString } from './helpers';

export function useTranslation({
  translatedStringKeyPath,
  translationType = TranslationTypes.DEFAULT,
}) {
  const translations = useSelector(dataSelectors.translations);
  const translatedStringSet = get(
    translations,
    translatedStringKeyPath,
    get(DEFAULT_TRANSLATIONS, translatedStringKeyPath)
  );
  return translatedStringSet?.[translationType];
}

export function useStringTranslatorFunction() {
  const translations = useSelector(dataSelectors.translations);
  return function translateStringFn(stringWithTemplateTokens) {
    return translateString(stringWithTemplateTokens, translations);
  };
}
